import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { CoreButton } from 'src/components/core'
import { track } from '@amplitude/analytics-browser'
import { Link as RouterLink } from 'react-router-dom'
import UserType from 'src/model/user-types'

const UpgradeButton = () => {
  const daysLeft = window.CONSTANTS?.TRIAL_DAYS_REMAINING
  const isTrial = UserType.isTrialEquivalent(window.CONSTANTS?.USER_ROLE_ID)

  return (
    <Box style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      {isTrial && daysLeft > 0 && (
        <>
          <Typography
            style={{
              color: 'var(--mcg-dark, #002E47)',
              fontFamily: '"Be Vietnam", sans-serif',
              fontSize: 14,
              fontWeight: 500,
              lineHeight: '18px',
              whiteSpace: 'nowrap',
            }}
          >
            {daysLeft} days left in trial.
          </Typography>

          <CoreButton
            to="/pricing"
            variant="contained"
            component={RouterLink}
            onClick={() =>
              track('limit_warning_upgrade', { from: 'dashboard_upgrade_button' })
            }
            style={{
              display: 'flex',
              height: 32,
              padding: '7.5px 12px',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 10,
              backgroundColor: '#FB9D01',
              color: '#fff',
              textAlign: 'center',
              fontFamily: 'Inter',
              fontSize: 14,
              fontWeight: 500,
              lineHeight: 'normal',
              borderRadius: 6,
              textTransform: 'none',
              boxShadow: 'none',
              border: 'none',
              minWidth: 'unset',
              whiteSpace: 'nowrap',
              marginRight: 8,
            }}
          >
            Upgrade now
          </CoreButton>
          <Box
            style={{
              width: 1,
              height: 32,
              backgroundColor: '#E5E7EB',
            }}
          />
        </>
      )}
    </Box>
  )
}

export default UpgradeButton
